import { purchaseActions } from "modules/purchase";
import { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "store";

import type { Store } from "store";

type UseOrderTransactionInput = {
  /** falseの間は取得を始めない。取得元の切り替え中に二重取得しないため */
  enabled: boolean;
  orderId: string;
};

type UseOrderTransactionOutput = {
  transaction?: Store["purchase"]["activeTransactionMap"][string];
  isLoadingTransaction: boolean;
  isInvalidTransaction: boolean;
};

export const useOrderTransaction = (
  input: UseOrderTransactionInput
): UseOrderTransactionOutput => {
  const { enabled, orderId } = input;
  const dispatch = useDispatch();
  const activeTransactionMap = useSelector(
    (state: Store) => state.purchase.activeTransactionMap
  );

  useEffect(() => {
    if (!enabled) return;
    dispatch(purchaseActions.fetchUserActiveTransactions.started());
  }, [dispatch, enabled]);

  // 無効な間はReduxに残っている注文も返さない。別画面が読み込んだ注文で後続の取得が走るのを防ぐ
  const transaction = useMemo(() => {
    if (!enabled || !activeTransactionMap) return undefined;
    const targetTransaction = activeTransactionMap[String(orderId)];
    return targetTransaction;
  }, [activeTransactionMap, enabled, orderId]);

  const isLoadingTransaction = !enabled || !activeTransactionMap;
  const isInvalidTransaction = !isLoadingTransaction && !transaction;

  return {
    transaction,
    isLoadingTransaction,
    isInvalidTransaction,
  };
};
